import { assetsUrl, environment, version } from '@awork/environments/environment'
import type { Language, LanguageObj } from '@awork/_shared/functions/get-language'
import { setLanguage } from '@awork/_shared/functions/get-language'
import getLanguage from '@awork/_shared/functions/get-language'
import isTest from '@awork/_shared/functions/is-test'
import { betterFetch } from '@awork/_shared/functions/better-fetch'
import type { ISOLanguage } from '@awork/_shared/models/account.model'
import { setGlobalQ } from '@awork/_shared/functions/global-variables'

/**
 * Fetches the translation and assign it to the `q` global variable
 * @param {boolean} [set=true]
 * @returns {() => Promise<void>}
 */
export function fetchTranslation(set = true): () => Promise<void> {
  return async () => {
    let languageObj: LanguageObj

    if (set) {
      languageObj = await setLanguage()
    } else {
      languageObj = {
        language: getLanguage() as Language,
        iso: getLanguage(true) as ISOLanguage
      }
    }

    if (q?.translations?.currentLang) {
      if (q.translations.currentLang !== languageObj.iso && !isTest()) {
        // TODO: Reload page to fetch the correct language, temp fix
        window.location.reload()
      }

      return
    }

    // TODO: Use CDN (overcome cache issue)
    // const url = `${assetsUrl}i18n/${languageObj.language}.json?v=${version}`

    // Load the current runner translations even when an earlier deployment is cached by the service worker.
    const bypassServiceWorker = environment === 'runner' ? '&ngsw-bypass' : ''
    const url = `./assets/i18n/${languageObj.language}.json?v=${version}${bypassServiceWorker}`
    const cache: RequestCache = environment === 'local' || environment === 'runner' ? 'no-store' : 'force-cache'
    const res = await betterFetch(url, { cache })
    const translations: QTranslations = await res.json()

    translations.currentLang = languageObj.iso

    // Set the global variable using the secure utility function
    setGlobalQ({ translations, assetsUrl })
  }
}
